export { default as DiscountTag } from "./DiscountTag";
